module.exports = __webpack_public_path__ + "img/sandyGlobe.dfe03d93.svg";